<script lang="ts">
  import { cx } from '@emotion/css';
  import { ResponsiveVars } from '@twist/core';
  import type { CustomBlockComponentProps } from '@portabletext/svelte';
  import { toFluidVarInput } from '$lib/utils/fluidity';

  export let portableText: CustomBlockComponentProps<{
    children: {
      marks: string[];
    }[];
    listItem: 'number' | 'bullet';
  }>;

  $: isMachinaFont =
    portableText.value.children[0] &&
    portableText.value.children[0].marks.includes('fontsPPNeueMachina');

  const responsiveVars = new ResponsiveVars()
    .addFluid('margin-bottom', toFluidVarInput(2, 2))
    .addFluid('font-size', toFluidVarInput(12, 18))
    .toCSS();
</script>

<li
  class={cx(responsiveVars, isMachinaFont ? 'pp-neue-machina' : 'pilat-wide')}
  class:dot={portableText.value.listItem === 'bullet'}
  class:number={portableText.value.listItem === 'number'}
>
  <span>
    <slot />
  </span>
</li>

<style lang="scss">
  li {
    display: list-item;
    margin-bottom: var(--margin-bottom);

    &:last-of-type {
      margin-bottom: 0;
    }

    span {
      display: inline;
      margin-left: 8px;
      line-height: 160%;
      font-size: var(--font-size);
      font-weight: 400;
    }

    &.number {
      &::marker {
        line-height: 160%;
        font-size: var(--font-size);
        font-weight: 400;
      }

      &.pp-neue-machina {
        &::marker {
          font-family: var(--font-family-secondary);
        }
      }

      &.pilat-wide {
        &::marker {
          font-family: var(--font-family-primary);
        }
      }
    }
  }
</style>
